import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
import { RELOGIN_URL } from "../../../utils/constants";
import { Button } from "react-bootstrap";
import { getCookie, setRedirectToken, setMbServerToken, clearAuthTokens,getMbServerToken, deleteCookie } from "../../../utils/cookieUtils";
import { trackEvent } from "../../../config/eventHandlers";

export default function SignIn() {
  const navigate = useNavigate();
  const [message, setMessage] = useState();
  const [showLoginAction, setShowLoginAction] = useState(false);
  const [loader, setLoader] = useState(true);
  let apiUrl = process.env.REACT_APP_WAPI_URL;
  let url1 = window.location;
  let url2 = new URL(url1);
  const searchParams = new URLSearchParams(url2.search);
  
const accessToken = searchParams.get("accessToken")?.trim() || getMbServerToken()?.trim() || "";

const shortToken = searchParams.get("shortToken")?.trim() || getCookie("redirect") || "";

const source = searchParams.get("source")?.trim() || "";

  useEffect(() => {
    localStorage.clear();
    deleteCookie("redirect");
    localStorage.setItem("source", source);
    if (shortToken) {
      getUserLongToken(shortToken);
    } else if (!shortToken && accessToken) {
      fetchUserDetails(accessToken);
    } else if (!shortToken && !accessToken) {
      clearAuthTokens()
      setLoader(false);
      setShowLoginAction(true);
      setMessage("Authentication required. Please log in to continue.");
      
      const eventPayload = {
        ReimbusementUnableToLoginReason: "No authentication token found - Missing both shortToken and accessToken",
        screenName: "Login Page",
      };
      trackEvent.loginPopIssue(eventPayload);
    }
  }, []);

  async function fetchUserDetails(longToken) {
    try {
      let data = {
        isSSOLogin: true,
        authServerAccessToken: longToken,
      };
      let config = {
        method: "post",
        url: `${apiUrl}/MarketPlaceLogon`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      let MarketPlaceLogonResp = response.data;
      if (MarketPlaceLogonResp && MarketPlaceLogonResp.isSuccess) {
        localStorage.setItem(
          "loggedInUserName",
          MarketPlaceLogonResp?.user?.userDetails?.displayName
        );
        setMbServerToken(longToken.trim());
        setRedirectToken(MarketPlaceLogonResp?.user?.token);
        localStorage.setItem(
          "entityPolicyId",
          MarketPlaceLogonResp?.user?.userDetails?.entityPolicyDetails
            ?.entityPolicyId
        );
        localStorage.setItem(
          "subscriptionId",
          MarketPlaceLogonResp?.user?.userDetails?.entityPolicyDetails
            ?.primarySubscriptionId
        );
        navigate("/reimbursements");
      } else if (!MarketPlaceLogonResp.isSuccess) {
        localStorage.clear();
        clearAuthTokens();
         setLoader(false);
        setShowLoginAction(true);
        setMessage("Session expired. Please log in again.");
        
        const eventPayload = {
          ReimbusementUnableToLoginReason: `MarketPlaceLogon API failed - isSuccess: false`,
          screenName: "Login Page",
        };
        trackEvent.loginPopIssue(eventPayload);
      } else {
        setLoader(false);
        setShowLoginAction(false);
        setMessage("Unable to Fetch User Details.");
        
        const eventPayload = {
          ReimbusementUnableToLoginReason: "MarketPlaceLogon API returned unexpected response",
          screenName: "Login Page",
        };
        trackEvent.loginPopIssue(eventPayload);
      }
    } catch (e) {
      setLoader(false);
      setShowLoginAction(true);
      setMessage("Connection error. Please check your internet and try again.");
      
      const eventPayload = {
        ReimbusementUnableToLoginReason: `MarketPlaceLogon API error - ${e.message || e.toString()}`,
        screenName: "Login Page",
      };
      trackEvent.loginPopIssue(eventPayload);
    }
  }

  async function getUserLongToken(shortToken) {
    let data = {
      shortToken: shortToken,
    };
    let config = {
      method: "post",
      url: `${apiUrl}/GetUserLongToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      let response = await axios(config);
      if ((response.status === 200) && (response.data.isSuccess === true)) {
        let LongToken = response.data.encryptedToken;
        setMbServerToken(LongToken.trim());
        await fetchUserDetails(LongToken);
      } else {
        setLoader(false);
        setShowLoginAction(true);
        setMessage("Session expired. Please log in again.");
        
        const eventPayload = {
          ReimbusementUnableToLoginReason: `GetUserLongToken API failed - Status: ${response.status}, isSuccess: ${response.data.isSuccess}`,
          screenName: "Login Page",
        };
        trackEvent.loginPopIssue(eventPayload);
      }
    } catch (e) {
      setLoader(false);
      setShowLoginAction(true);
      setMessage("Unable to fetch User Information");
      
      const eventPayload = {
        ReimbusementUnableToLoginReason: `GetUserLongToken API error - ${e.message || e.toString()}`,
        screenName: "Login Page",
      };
      trackEvent.loginPopIssue(eventPayload);
    }
  }
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      {loader ? (
        <CircularProgress color="inherit" />
      ) : (
        <div
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            background: "white",
            borderRadius: "10px",
            margin: "0 auto",
            color: "black",
            padding: "2rem",
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
            maxWidth: 420,
          }}
        >
          <p
            style={{
              display: "inline",
              alignItems: "center",
              textAlign: "center",
              margin: "0",
            }}
          >
            <strong>{message}</strong>
          </p>
          {showLoginAction && (
            <Button
              id="create-claim-btn"
              variant="primary"
              style={{
                border: "blue",
                cursor: "pointer",
                text: "white",
              }}
              className={"border-radius-10"}
              onClick={() => (window.location.href = RELOGIN_URL)}
            >
              Login
            </Button>
          )}
        </div>
      )}
    </Backdrop>
  );
}
